var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 860,
    height: 106,
    viewBox: "0 0 860 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#B3D7FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 44,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#B3D7FC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 1,
    y: 88,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#B3D7FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 44,
    width: 169,
    height: 12,
    rx: 6,
    fill: "#B3D7FC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 38,
    y: 88,
    width: 145,
    height: 12,
    rx: 6,
    fill: "#B3D7FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 44,
    width: 54,
    height: 12,
    rx: 6,
    fill: "#B3D7FC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 416,
    y: 88,
    width: 54,
    height: 12,
    rx: 6,
    fill: "#B3D7FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535,
    y: 44,
    width: 91,
    height: 12,
    rx: 6,
    fill: "#B3D7FC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 535,
    y: 88,
    width: 91,
    height: 12,
    rx: 6,
    fill: "#B3D7FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    width: 44,
    height: 12,
    rx: 6,
    fill: "#B3D7FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    width: 44,
    height: 12,
    rx: 6,
    fill: "#B3D7FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535,
    width: 57,
    height: 12,
    rx: 6,
    fill: "#B3D7FC"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 27.5,
    x2: 860,
    y2: 27.5,
    stroke: "#B3D7FC"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    y1: 71.5,
    x2: 860,
    y2: 71.5,
    stroke: "#B3D7FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 836,
    y: 38,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#B3D7FC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 836,
    y: 82,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#B3D7FC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.eb46c323a9a15810c85d6e741369fe26.svg";
export { ForwardRef as ReactComponent };